import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ab6a3d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for", "checked"]
const _hoisted_2 = { class: "app-checkbox-input-container" }
const _hoisted_3 = ["id", "value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "app-checkbox-outline" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "app-checkbox-checked" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    for: _ctx.id,
    checked: _ctx.isChecked ? '' : undefined,
    class: "app-checkbox"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkedItems) = $event)),
        id: _ctx.id,
        value: _ctx.value,
        type: "checkbox",
        class: "app-checkbox-input"
      }, null, 8, _hoisted_3), [
        [_vModelCheckbox, _ctx.checkedItems]
      ]),
      _hoisted_4,
      _hoisted_5
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 8, _hoisted_1))
}